import { Component, OnInit } from '@angular/core';

@Component({
  //selector: 'lud-page-not-found',
  template: `
<div class="container">
  <div class= "jumbotron">
    <h2>404 - Page Not Found! </h2>
  </div>
</div>
`
})
export class PageNotFoundComponent implements OnInit {
  static route = '**';

  constructor() { }

  ngOnInit() {
  }

}
